/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Chat_Tool_Result_Not_ExecutedInputs */



/**
* | output |
* | --- |
* | "This action was not carried out." |
*
* @param {Chat_Tool_Result_Not_ExecutedInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const chat_tool_result_not_executed = /** @type {((inputs?: Chat_Tool_Result_Not_ExecutedInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Chat_Tool_Result_Not_ExecutedInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Diese Aktion wurde nicht ausgeführt.")
	return /** @type {LocalizedString} */ ("This action was not carried out.")
});